
import axiosClient from "./axiosClient";
import axiosClientNotLogin from "./axiosClientNotLogin";

const PREFIX_URL = "crm/cau-hinh";

const configApi = {
    getAll: (params) => {
        const url = `${PREFIX_URL}/index`;
        return axiosClient.get(url, { params });
    },
    getInfo: (params = {}) => {
        const url = `${PREFIX_URL}/getInfo`;
        return axiosClient.get(url, { params });
    },
    update: (params) => {
        const url = `${PREFIX_URL}/update`;
        return axiosClient.post(url, params);
    },
    getListUserCanConnect: (params) => {
        const url = `${PREFIX_URL}/getListUserCanConnect`;
        return axiosClient.get(url, { params });
    },
    getUserListView: (params) => {
        const url = `${PREFIX_URL}/getUserListView`;
        return axiosClient.get(url, { params });
    },
    addUserConnect: (data) => {
        const url = `${PREFIX_URL}/addUserConnect`;
        return axiosClient.post(url, data);
    },
    deleteUserConnect: (data) => {
        const url = `${PREFIX_URL}/deleteUserConnect`;
        return axiosClient.post(url, data);
    },
    addGmailConfig: (data) => {
        const url = `${PREFIX_URL}/addGmailConfig`;
        return axiosClient.post(url, data);
    },
    getAllMenuConfig: (params) => {
        const url = `${PREFIX_URL}/getAllMenuConfig`;
        return axiosClientNotLogin.get(url, { params });
    },
}

export default configApi;
